import { render } from "./WatchlistCard.vue?vue&type=template&id=1d4e2940&ts=true"
import script from "./WatchlistCard.vue?vue&type=script&lang=ts"
export * from "./WatchlistCard.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__